import { Globe, Move } from 'lucide-react';

import { GuidanceLine } from './GuidanceLine';

export interface PhotoGuidanceProps {
  /** Id of the wrapper, so the crop box can point at the framing hint. */
  id: string;
  hasPhoto: boolean;
  cropping: boolean;
}

/** What customers see, or what to do while framing a photo. */
export function PhotoGuidance({ id, hasPhoto, cropping }: PhotoGuidanceProps) {
  return (
    <div id={id} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <GuidanceLine icon={<Globe size={13} color="var(--nb-primary)" aria-hidden="true" />}>
        {hasPhoto
          ? 'This is the photo customers see when they book at this venue.'
          : 'Customers see a placeholder image when they book here until a photo is added.'}
      </GuidanceLine>
      {cropping && (
        <GuidanceLine icon={<Move size={13} color="var(--nb-muted)" aria-hidden="true" />}>
          Drag to reposition or use the arrow keys. Everything outside the box is trimmed.
        </GuidanceLine>
      )}
    </div>
  );
}
